export enum Names {
    INSTANT_QUOTE = 'instant quote',
}
